import {
  createContext,
  useContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
} from "react";

interface PagesContextType {
  pages: Dash[] | null;
  setPages: Dispatch<SetStateAction<Dash[] | null>>;
  setCheckLogin: Dispatch<SetStateAction<boolean>>;
  checkLogin: boolean;
  filterDate: dateFilter;
  setFilterDate: Dispatch<SetStateAction<dateFilter>>;
  loadingPages: boolean;
  setLoadingPages: Dispatch<SetStateAction<boolean>>;
}

const PagesContext = createContext<PagesContextType | undefined>(undefined);

export const usePages = () => {
  const context = useContext(PagesContext);
  if (!context) {
    throw new Error("usePages deve ser usado dentro do PagesProvider");
  }
  return context;
};

export const PagesProvider = ({ children }: { children: ReactNode }) => {
  const [pages, setPages] = useState<Dash[] | null>(null);
  const [checkLogin, setCheckLogin] = useState<boolean>(false);
  const [filterDate, setFilterDate] = useState<dateFilter>({
    timeStart: null,
    timeEnd: null,
    option: null,
  });
  const [loadingPages, setLoadingPages] = useState<boolean>(false);

  return (
    <PagesContext.Provider
      value={{
        pages,
        setPages,
        setCheckLogin,
        checkLogin,
        filterDate,
        setFilterDate,
        loadingPages,
        setLoadingPages,
      }}
    >
      {children}
    </PagesContext.Provider>
  );
};
